import React from 'react';
import { Button, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useStore } from '../../store/store';
import { getPrimaryDark } from '../../constants/constants';
import ConfigDrawer from './ConfigDrawer';

// Contenu de l'onglet "Paramètres" du panel de gauche : le toggle "Masquer
// séparation de chapitre" (ex-panel de droite), le toggle "Afficher le
// formulaire par défaut" (modèle, admin), le bouton d'accès à la modale
// de configuration (fallback, ex-bouton engrenage de la top bar) et la liste
// des onglets de configuration ouvrant chacun un Drawer gauche (ConfigDrawer).
// L'ouverture de la modale passe par le store (requestOpenConfigurator) car sa
// logique collab (claim du verrou configurateur) vit dans la Navbar.
const SettingsPanel = () => {
  const { t } = useTranslation();
  const isAdmin = useStore(({ user }) => user?.isAdmin);
  const currentDocument = useStore(({ currentDocument }) => currentDocument);
  const displayChapterSeparation = useStore(
    ({ configuration }) => configuration.displayChapterSeparation ?? true
  );
  const setDisplayChapterSeparation = useStore((state) => state.setDisplayChapterSeparation);
  const showFormByDefault = useStore(
    ({ configuration }) => configuration.defaultDocumentView === 'form'
  );
  const setConfiguration = useStore((state) => state.setConfiguration);
  const requestOpenConfigurator = useStore((state) => state.requestOpenConfigurator);

  // Même accès que l'ex-bouton engrenage : configurateur réservé à l'admin sur
  // un modèle.
  const canConfigure = currentDocument.type === 'template' && isAdmin;

  // Même bleu que le token antd colorPrimary (cf. Layout.jsx) qui pilote le
  // Switch : mode-dépendant (navy proposal / violet template).
  const accentColor = getPrimaryDark(currentDocument.type === 'template');

  return (
    <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 16, fontSize: 11 }}>
      {/* Bouton d'accès à la modale de configuration (fallback) — masqué.
      {canConfigure && (
        <Button
          className='style_btn_right_side'
          style={{ color: accentColor, borderColor: accentColor, '--btn-accent-color': accentColor, fontSize: 13 }}
          icon={<FontAwesomeIcon icon={icon({ name: 'gear', style: 'light' })} style={{ marginRight: 8 }} />}
          onClick={() => requestOpenConfigurator()}
          ghost
        >
          {t('configuration')}
        </Button>
      )}
      */}
      <Switch
        className='right-panel-switch'
        style={{ width: 210 }}
        checkedChildren={t('hide-chapter-separation')}
        unCheckedChildren={t('show-chapter-separation')}
        checked={displayChapterSeparation}
        onClick={() => setDisplayChapterSeparation(!displayChapterSeparation)}
      />
      {canConfigure && (
        <Switch
          className='right-panel-switch'
          style={{ width: 210 }}
          title="À l'ouverture d'une proposition, le formulaire s'affiche à la place du document."
          checkedChildren='Afficher le formulaire par défaut'
          unCheckedChildren='Afficher le formulaire par défaut'
          checked={showFormByDefault}
          onClick={(checked) => setConfiguration({ defaultDocumentView: checked ? 'form' : 'document' })}
        />
      )}
      {canConfigure && <ConfigDrawer />}
    </div>
  );
};

export default SettingsPanel;
